import styled from 'styled-components';
import FailedSvg from '../../assets/mytrips/failed.svg';

const FailedIcon = styled(FailedSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '3.2rem'};
  height: ${props => props.height || '3.2rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default FailedIcon;
